import { render } from "./HorsePreviewMainData.vue?vue&type=template&id=0a58f07f"
import script from "./HorsePreviewMainData.vue?vue&type=script&lang=js"
export * from "./HorsePreviewMainData.vue?vue&type=script&lang=js"

import "./HorsePreviewMainData.vue?vue&type=style&index=0&id=0a58f07f&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__